export default __webpack_public_path__ + "static/media/falcon.0b30abe9.png";